var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { FB_APP_ID, STATIC_ASSETS_BASE, STOCK_STATUS_STRUCTURED_DATA, TWITTER_SITE, } from './constants';
import links from './links';
import meta from './meta';
export var twitterConfig = function (matureContent, handle) {
    if (matureContent === void 0) { matureContent = false; }
    if (handle === void 0) { handle = undefined; }
    return {
        site: TWITTER_SITE,
        cardType: matureContent ? '' : 'summary_large_image',
        handle: handle,
    };
};
export var getAggregateRating = function (reviewSummary) {
    var _a, _b;
    var rating = (_a = reviewSummary === null || reviewSummary === void 0 ? void 0 : reviewSummary.rating) !== null && _a !== void 0 ? _a : 0;
    var roundedRating = Math.round(rating * 10) / 10;
    var bestRating = 5;
    var ratingCount = (_b = reviewSummary === null || reviewSummary === void 0 ? void 0 : reviewSummary.count) !== null && _b !== void 0 ? _b : 0;
    var aggregateRating = {
        ratingValue: roundedRating,
        bestRating: bestRating,
        ratingCount: ratingCount,
    };
    if ((aggregateRating === null || aggregateRating === void 0 ? void 0 : aggregateRating.bestRating) && (aggregateRating === null || aggregateRating === void 0 ? void 0 : aggregateRating.ratingCount)) {
        return __assign({ '@type': 'AggregateRating' }, aggregateRating);
    }
    return null;
};
export var getJsonLdData = function (stockStatus, price, reviewSummary) {
    var _a;
    var aggRating = getAggregateRating(reviewSummary);
    var returnPolicy = {
        '@type': 'MerchantReturnPolicy',
        returnPolicyCategory: 'https://schema.org/MerchantReturnFiniteReturnWindow',
        merchantReturnDays: 30,
        returnMethod: 'https://schema.org/ReturnByMail',
        returnFees: 'https://schema.org/FreeReturn',
    };
    var offers = {
        price: ((_a = price === null || price === void 0 ? void 0 : price.discount) === null || _a === void 0 ? void 0 : _a.amount) && price.discount.amount > 0
            ? price.discount.amount
            : price === null || price === void 0 ? void 0 : price.amount,
        priceCurrency: price === null || price === void 0 ? void 0 : price.currency,
        itemCondition: 'https://schema.org/NewCondition',
        availability: STOCK_STATUS_STRUCTURED_DATA[stockStatus],
        hasMerchantReturnPolicy: returnPolicy,
    };
    return {
        aggRating: aggRating,
        offers: offers,
    };
};
var config = {
    titleTemplate: '%s | Redbubble',
    defaultTitle: 'Redbubble',
    additionalLinkTags: links,
    additionalMetaTags: meta,
    facebook: {
        appId: FB_APP_ID,
    },
    twitter: twitterConfig(),
    openGraph: {
        // TODO localize?
        title: 'Redbubble',
        description: 'Millions of unique designs by independent artists. Find your thing.',
        siteName: 'Redbubble',
        images: [
            {
                url: "".concat(STATIC_ASSETS_BASE, "/og-image.jpeg"),
                width: 1200,
                height: 630,
                alt: 'Redbubble',
            },
        ],
    },
};
export default config;
